
export const menuItemType = {
    link: 'link',
    dropdown: 'dropdown',
    heading: 'heading'
  }

  const initMenu = [
     { name: 'Account', path: '/', type: menuItemType.link, icon: 'users' },
    //  { name: 'Mailing lists', path: '/mailinglists', type: menuItemType.link, icon: 'list-alt' },
    //  { name: 'Email templates', path: '/emailtemplates', type: menuItemType.link, icon: 'envelope-open-text' }
  ]

  export function getMenu(user) {
    return initMenu;
  }